import { render, staticRenderFns } from "./ShopPromo.vue?vue&type=template&id=da2b414e&scoped=true&"
import script from "./ShopPromo.vue?vue&type=script&lang=js&"
export * from "./ShopPromo.vue?vue&type=script&lang=js&"
import style0 from "./ShopPromo.vue?vue&type=style&index=0&id=da2b414e&prod&lang=css&"
import style1 from "./ShopPromo.vue?vue&type=style&index=1&id=da2b414e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2b414e",
  null
  
)

export default component.exports